'use client'

import { useEffect } from 'react'
import { useAuthStore } from '@/lib/stores/auth-store'
import { useUmamiIdentify } from '@/hooks/use-umami-identify'

export function AuthProvider({ children }: { children: React.ReactNode }) {
  // Sincroniza o usuário autenticado com o distinct id do Umami
  // (no-op se o tracker ainda não carregou).
  useUmamiIdentify()

  useEffect(() => {
    // Aguardar rehydration completar antes de verificar auth
    // Isso evita race condition onde checkAuth é chamado antes do store estar hidratado
    const unsub = useAuthStore.persist.onFinishHydration(() => {
      useAuthStore.getState().checkAuth()
    })

    // Se já está hidratado (ex: navegação client-side), verificar imediatamente
    if (useAuthStore.persist.hasHydrated()) {
      useAuthStore.getState().checkAuth()
    }

    return unsub
  }, [])

  // IMPORTANTE: Sempre renderiza children para evitar hydration mismatch
  // A lógica de auth é executada no useEffect sem bloquear a renderização
  return <>{children}</>
}